import Layout from '@/components/layout/Layout'
import Login from '@/components/login/Login'

// import store from '@/store'
import { asyncComponent } from './utils'
import pubRoutes from './pubRoutes'

let routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/settlement',
    name: 'Settlement',
    component: Layout,
    children: [
      {
        path: 'view',
        name: 'SettlementView',
        components: {
          default: asyncComponent('settlement/SettlementView')
        }
      }
    ]
  },
  {
    path: '/penalty',
    name: 'Penalty',
    component: Layout,
    children: [
      {
        path: 'view',
        name: 'PenaltyView',
        components: {
          default: asyncComponent('penalty/PenaltyView')
        }
      }
    ]
  },
  {
    path: '/complaint',
    name: 'ServiceComplaint',
    component: Layout,
    children: [
      {
        path: 'view',
        name: 'ServiceComplaintView',
        components: {
          default: asyncComponent('complaint/ServiceComplaintView')
        }
      }
    ]
  },
  {
    path: '/accounts',
    name: 'CompanyAccounts',
    component: Layout,
    children: [
      {
        path: 'view',
        name: 'CompanyAccountsView',
        components: {
          default: asyncComponent('company/CompanyAccountsView')
        }
      }
    ]
  },

  // #region 광고 관리
  {
    path: '/ad',
    redirect: '/ad/requests',
  },
  {
    path: '/ad/requests',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdRequestList',
        components: {
          default: asyncComponent('ad/requests/RequestListView.vue'),
        },
        meta: {
          pageTitle: '신청 내역',
        },
      },
      {
        path: 'write',
        name: 'AdRequestWrite',
        components: {
          default: asyncComponent('ad/requests/RequestWriteView.vue'),
        },
        meta: {
          pageTitle: '신청서 작성',
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdRequestDetail',
        components: {
          default: asyncComponent('ad/requests/RequestDetailView.vue'),
        },
        meta: {
          pageTitle: '신청서 상세',
        },
      },
    ],
  },
  {
    path: '/ad/campaign-reports',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdCampaignReportList',
        components: {
          default: asyncComponent('ad/campaign-reports/ReportListView.vue'),
        },
        meta: {
          pageTitle: '캠페인 리포트',
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdCampaignReportDetail',
        components: {
          default: asyncComponent('ad/campaign-reports/ReportDetailView.vue'),
        },
        meta: {
          pageTitle: '캠페인 리포트 상세',
        },
      },
    ],
  },
  // #endregion

  // 계약 이력
  {
    path: '/contractHistory',
    name: 'ContractHistory',
    component: Layout,
    children: [
      {
        path: 'view',
        name: 'ContractHistoryView',
        components: {
          default: asyncComponent('contractHistory/ContractHistoryView')
        }
      }
    ]
  },

  {
    path: '/etc',
    name: 'Etc',
    component: Layout,
    children: [
      {
        path: 'dataerror',
        name: 'EtcDataerror',
        components: {
          default: asyncComponent('etc/Error')
        }
      }
    ]
  },
]

export default [...routes, ...pubRoutes]
